<template>
  <div class="blockSelect ">

    <div class="content ">
      <a class="close-button" v-on:click="$emit('close');">
        <i class="fas fa-times"></i>
      </a>
      <div class="columns">
        <div class="column">
          <h2 class="title-modal is-size-4 has-text-weight-bold has-text-centered">{{ $t("download") }} :
            {{ $t(document.type) }}</h2>
        </div>
      </div>
      <div class="columns">
        <div class="column is-full-mobile" v-if="links.length>1">
          <h3 class="subtitle-modal is-size-6 is-uppercase has-text-weight-bold is-color-red">
            {{ $t("type") }}</h3>

          <div class="field" v-for="link in links">
            <b-radio
                v-model="docLink"
                :native-value="link"
                @click="changeLink(link)"
            >
              {{ link.label }}
            </b-radio>
          </div>

        </div>
        <div class="column  is-full-mobile">
          <h3 class="subtitle-modal is-size-6 is-uppercase has-text-weight-bold is-color-red">
            {{ $t("measure_system") }}</h3>


          <div class="field" v-for="unit in units">
            <b-radio
                v-model="docUnit"
                :native-value="unit.code"
                @click="changeUnit(unit.code)"
            >
              {{ unit.label }}
            </b-radio>
          </div>


        </div>
        <div class="column  is-full-mobile">
          <h4 class="subtitle-modal is-size-6 is-uppercase has-text-weight-bold is-color-red">{{
              $t("language")
            }}</h4>

          <!-- USING in order by column
            <div class="columns">
            <div class="column is-full-mobile" v-for="column in columnsLocale">
              <div class="field"  v-for="locale in column">
            <b-radio
                v-model="docLang"


                :native-value="locale.code"

                @click="changeLang(locale.code)"
            >
              {{ locale.label }}
            </b-radio>
              </div>
            </div>
            </div>

            -->
          <b-select class="is-rounded select  " @change="changeLang($event)" v-model="docLang">
            <option v-for="locale in orderedLocales" :value="locale.code" :native-value="locale.code">
              {{ locale.label }}
            </option>
          </b-select>

        </div>

      </div>
      <div class="columns">
        <div class="column has-text-centered">

          <a v-on:click="$emit('close');prepareDocument()" type="button"
             class="button is-primary is-background-color-red is-rounded is-uppercase is-large ">{{
              $t('download')
            }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {downloadBlobFilename, localeToKebabCase, slugify, triggerTrackingEvent} from "@/common/helpers";
import axios from "axios";
import serliAssetService from "@/services/serli/asset";
import assetService from "@/services/akeneo/asset";
import {mapState} from "vuex";
import {locales} from "@/common/localesList";
import {MEDIA_URL,BROCHURE_URL} from "@/common/config";

export default {
  name: 'AssociatedBrochuresSelect',
  props: {
    docType: {
      type: String,
      default: '',
    },
    document: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      docUnit: this.$store.state.settings.unitType,
      docLang: this.$store.state.settings.locale,
      docLink: '',
      locales: locales,
      units: [
        {code: 'metric', label: this.$t("metric")},
        {code: 'imperial', label: this.$t('imperial')},
        // {code: '', label: this.$t('both')},
      ],
    }
  },
  computed: {
    ...mapState({
      productDatas: state => state.sheet.productDatas,
      isPhone: state => state.settings.isPhone,
      country: state => state.settings.country,
      markets: state => state.settings.markets,
      //Using for order by column
      // columnsLocale: function () {
      //  let colsLocale = (this.isPhone) ? 1 : 2;
      //  let columns = [];
      //  let mid = Math.ceil(Object.keys(this.orderedLocales).length / colsLocale);
      //
      //  for (let col = 0; col < colsLocale; col++) {
      //    columns.push(Object.entries(this.orderedLocales).slice(col * mid, col * mid + mid).map(entry => entry[1]));
      //  }
      //  return columns;
      //}

      docCountry() {
        const country = this.docLang.split('_')
        if (country.length > 1) {
          return country[1]
        }
        return country[0]
      },

      links() {
        let links = []
        if (this.document.machine) links.push({
          'label': this.$t('machine'),
          'file_label': slugify(this.productDatas.identifier),
          'url': `&machineId=${this.productDatas.identifier}`,
        })
        /*
        if (this.document.category) links.push({
          'label': this.$t('range'),
          'file_label': slugify(this.productDatas.categories[0]),
          'url': `&machineCategory=${this.productDatas.categories[0]}`,
        })*/

        if (this.productDatas.markets && this.document.markets && this.document.type!=='machine-book') {
          let marketObj=null
          this.productDatas.markets.forEach((market)=>{
            marketObj=this.markets.find(x=>x.code===market)
            const marketsArray=["INDU","AGRI","CONS"]
            if(marketsArray.includes(market))
            links.push({
              'label': this.$t('market')+' : '+marketObj.label,
              'file_label': slugify(marketObj.label),
              'url': `&market=${market}`,
            })
          })
        }
        return links
      }
    }),
    orderedLocales() {
      return this.locales.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      })
    },
  },
mounted() {
  this.changeLink(this.links[0])
},
  methods: {
    changeUnit(val) {
      this.docUnit = val;
    },
    changeLang(val) {
      alert('ok');
      this.docLang = val;
    },
    changeLink(val) {
      this.docLink = val;
    },
    prepareDocument() {

      var reqUnit = '';
      if (this.docUnit !== '') reqUnit = '&unit=' + this.docUnit;
      if (this.productDatas && this.productDatas.name) {
        this.downloadDocument(
            {
              identifier: this.document.type,
              name: this.$t(this.document.type) + '-' + this.docLink.file_label + '-' + this.docLang,
              link: `${BROCHURE_URL}/${this.document.type}?country=${this.docCountry}${this.docLink.url}&locale=${this.docLang.replace('_', '-')}&unit=${this.docUnit}&format=pdf`,
              //link: `https://technical-datasheet-api.manitou.com/view/${this.docType}/${this.productDatas.identifier}?locale=${localeToKebabCase(this.docLang)}${reqUnit}&format=pdf&allowDisabled=1`,
              extension: 'pdf',
              filename: this.$t(this.document.type) + '-' + this.docLink.file_label + '-' + this.docLang + '.pdf',
              forceLinkDownload: true,
              product: this.productDatas,
            }
        )

        triggerTrackingEvent(`document_download`, `download_brochure`, `Téléchargement du PDF : ${this.productDatas.name}`)
      }
      return null;
    },
    async downloadDocument(document) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      const isIos = (!!userAgent.match(/iphone/i) || !!userAgent.match(/ipad/i));
      if (document.link) {
        if (document.forceLinkDownload) {
          if (isIos) {
            window.open(document.link)
          } else {
            this.startLoading(this.$t('download_in_progress_please_wait'));
            axios({
              url: document.link,
              method: 'GET',
              responseType: 'blob',
            })
                .then((response) => {
                  const blob = new Blob([response.data]);
                  saveAs(blob, document.filename)
                })
                .finally(() => this.stopLoading());
          }
        }
      } else {
        this.startLoading(this.$t('download_in_progress_please_wait'));
        if (document.isSerli) {
          const assetDatas = await serliAssetService.download(document.code, {
            locale: this.$store.state.settings.locale
          })
              .then((response) => {
                if (response.data.code === 200)
                  return response.data.data;
                else if (response.data.code === 500) {
                  console.error(response.data.message)
                  return null
                }
              })

          if (assetDatas) {
            if (isIos) {
              window.open(assetDatas.url, '_self')
            } else {
              const assetBlob = await axios({
                url: assetDatas.url,
                method: 'GET',
                responseType: 'blob',
              })
                  .then((response) => response.data)
              saveAs(new Blob([assetBlob]), document.filename)
            }
          } else {
            this.$buefy.dialog.alert({
              title: 'Error',
              message: this.$t('this_file_is_not_available_for_download'),
              type: 'is-danger'
            })
          }
        } else {
          let assetDatas = await assetService.download(document.code, {
            type: 'document',
            locale: this.$store.state.settings.locale
          }).then((response) => response.data)

          if (assetDatas.size > 0) {
            downloadBlobFilename(document.filename, new Blob([assetDatas]))
          } else if (this.$store.state.settings.locale !== 'en_US') {
            assetDatas = await assetService.download(document.code, {
              type: 'document',
              locale: 'en_US'
            }).then((response) => response.data);

            if (assetDatas.size > 0) {
              downloadBlobFilename(document.filename, new Blob([assetDatas]))
            }
          }
        }

        this.stopLoading();
      }
    }
  }


}
</script>

<style lang="scss">
.blockSelect {
  background: #ffffff;
  border-radius: 20px;

  .content {
    padding: 2rem;
    position: relative;
  }

  .close-button {
    position: absolute;
    right: 25px;
    top: 20px;
    font-size: 1.5rem;
    font-weight: lighter;
  }

  .title-modal {
    color: #101010;
    margin-bottom: 1rem;
  }

  .subtitle-modal {
    margin-bottom: 0.5rem;
  }


  .field {
    margin-bottom: 7px
  }

  .radio + .radio, .b-radio + .radio {
    margin-left: 0
  }


  .b-radio.radio input[type=radio] + .check {
    background: #f1f1f1;
    border: none;
    margin-right: 1rem;

    &:before {
      background-color: $brand-red
    }
  }

  .select:not(.is-multiple):not(.is-loading)::after {
    border-color: $brand-red
  }
}

.modal-close {
  display: none
}
</style>
